<template>
  <div>
    <el-row class="app_center_main" :style="conheight">
      <el-col :span="3" :key="app.id" v-for="app in apps">
        <el-card
          shadow="hover"
          class="card card_content"
          @click.native="click(app)"
        >
          <div
            :style="{ background: app.iconColor ? app.iconColor : '#1339E0' }"
            class="card-background"

          >
            <el-image
              class="app-image"
              :src="app.icon"
              
              style="width: 36px;height: 36px;border-radius: 8px 8px 8px 8px;margin-right: 16px;"
            ></el-image>
            <!-- <i v-if="app.icon.indexOf('icon') >= 0"
              :class="app.icon ? app.icon : 'el-icon-warning'"
              style="width: 36px;height: 36px;border-radius: 8px 8px 8px 8px;"
            ></i> -->
            <span class="card-title">{{ app.name }}</span>
          </div>
          
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import flow from "@/api/flow.js";
export default {
  name: "app-main",
  props: {
    apps: Array,
    pageResult: Object,
  },
  computed: mapState({
    token: function(mapState) {
      return mapState.login.currentUser.token;
    },
  }),
  data() {
    return {
      conheight: { height: window.innerHeight -112 + "px"},   
    };
  },
  methods: {
    //点击应用
    async click(app) {
      //1常规应用 2数据报表 3自定义视图 4图表 6表单 7模块 8启动流程
      let url = "";debugger;
      if (app.type == 4) {
        let content = JSON.parse(app.content);
        url = `/appContent/${app.type}/${content.id}/0`;
      } else if (app.type === 2) {
        let content = JSON.parse(app.content);
        url = `/appContent/${app.type}/${content.key}/0`;
      } else if (app.type === 3) {
        let content = JSON.parse(app.content);
        url = `/appContent/${app.type}/${content.alias}/${content.sqlAlias}`;
      } else if (app.type === 1) {
        url = `/appContent/${app.type}/${app.id}/0`;
      } else if (app.type === 6) {
        let content = JSON.parse(app.content);
        url = `/appContent/${app.type}/${content.id}/0`;
      } else if (app.type === 7) {
        url = `/appContent/${app.type}/${app.id}/0`;
      } else if (app.type === 8) {
        let content = JSON.parse(app.content);
        let resp = {};
        if (content.key) {
          resp = await flow.getMainByDefKey(content.key);
          url = `/fvue/agentStart/${resp.data.id}/0`;
        }else {
          //url = `/fvue/agentStart/${content.id}/0`;
          resp = await flow.getMainById(content.id);
          url = `/fvue/agentStart/${resp.data.id}/0`;
        }
      }else if (app.type===5) {
        url = app.content;
      }
      if (url)
        window.open(
          url,
          "_blank",
          "height=" +
            (screen.availHeight - 50) +
            ",width=" +
            (screen.availWidth - 10)
        );
    },
  },
};
</script>

<style lang="scss" scoped>



/deep/ .el-card{
  min-width: 192px;
  font-size:14px;
  color: #292B44;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 2px rgba(10,31,62,0.05);
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  border: 0px;
}
/deep/ .el-card:hover{
  min-width: 192px;
  background: #FFFFFF;
  box-shadow: 0px 6px 10px 4px rgba(10,34,62,0.12);
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
}

/deep/ .el-col{
  min-width: 192px;
}

/deep/ .card-background{
  position: relative;   
  display: flex;  
  align-items: center;
  padding-right: 10px;
}
.app_center_main{
  margin-top: 0px;
  overflow-x: auto;
  overflow-y: auto;
}

.card-title {
  padding-right: 10px;
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #292B44;
}
/deep/ .el-card__body{
  padding: 16px 0px 16px 16px;
  min-width: 192px;
  max-height: 36px;
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #292B44;
}

/deep/ .el-card__body :hover{
  font-size: 14px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1890FF;
}
/deep/ .el-col-3{
  margin : 24px 24px 0px 0px;
}

@media (min-width: 1920px) {
  /deep/.el-col-3 {
    width: 12%;
  }
}
@media (max-width:1024px) {
  /deep/.el-col-3 {
    width: 16%;
  }
}
</style>
